"use client"

import { useIsOrgAdmin } from "@/hooks/useIsOrgAdmin"
import { api } from "@/lib/api"
import { STALE_MEDIUM } from "./queryConfig.constants"
import { isSetupDone } from "@/utils/orgSetup.utils"

export function useIsSetupDone(): boolean {
    const { isOrgAdmin, isLoading } = useIsOrgAdmin()
    const { data } = api.setup.get.useQuery(undefined, {
        staleTime: STALE_MEDIUM,
        enabled: isOrgAdmin,
    })
    if (isLoading || !isOrgAdmin || !data) return true
    return isSetupDone({ completedSteps: data.completedSteps })
}
